import orderInstance from '../instance'

const closeCashRegister = () => {
	return orderInstance.post('/cashRegisterCloses')
}

export default closeCashRegister
